module.exports = __webpack_public_path__ + "assets/725652b6538556dceb960b7a79d6afce.png";